import { Controller} from "stimulus"

export default class extends Controller {
  static targets = ["field", "map", "latitude", "longitude", "city", "postal"]

  connect() {
    if (typeof (google) != "undefined"){
      this.initializeMap()
    }
  }

  initializeMap() {
    this.autocomplete()
  }

  autocomplete() {
    if (this._autocomplete == undefined) {
      this._autocomplete = new google.maps.places.Autocomplete(this.fieldTarget)
      this._autocomplete.setFields(['address_components', 'geometry', 'icon', 'name'])
      this._autocomplete.addListener('place_changed', this.locationChanged.bind(this))
    }
    return this._autocomplete
  }

  locationChanged() {
    let place = this.autocomplete().getPlace()
    if (!place.geometry) {
      window.alert("No details available for input: '" + place.name + "'");
      return;
    }

    this.latitudeTarget.value = place.geometry.location.lat()
    this.latitudeTarget.setAttribute('value', place.geometry.location.lat())
    this.latitudeTarget.dispatchEvent(new Event('change'))
    this.longitudeTarget.value = place.geometry.location.lng()
    this.longitudeTarget.setAttribute('value', place.geometry.location.lng())
    this.longitudeTarget.dispatchEvent(new Event('change'))
    this.setAddress(place.address_components)
  }

  preventSubmit(e) {
    if (e.key == "Enter") { e.preventDefault() }
  }

  setAddress(arr) {
    var route, street_num, city, postal
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].types[0] == "street_number") {
        street_num = arr[i].long_name
      }
      if (arr[i].types[0] == "route") {
        route = arr[i].long_name
      }
      if (arr[i].types[0] == "locality") {
        city = arr[i].long_name
      }
      if (arr[i].types[0] == "postal_code") {
        postal = arr[i].long_name
      }
    }
    this.cityTarget.value = city
    this.cityTarget.setAttribute('value', city)
    this.cityTarget.dispatchEvent(new Event('change'))
    this.postalTarget.value = postal
    this.postalTarget.setAttribute('value', postal)
    this.postalTarget.dispatchEvent(new Event('change'))
    this.fieldTarget.value = route + ' ' + street_num
    this.fieldTarget.setAttribute('value', route + ' ' + street_num)
    this.fieldTarget.dispatchEvent(new Event('change'))
  }
}